import { PencilIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function ProjectDetailsCard({ project, createdDate }) {
	const { t } = useTranslation()
	const stepsCount = Array.isArray(project?.steps) ? project.steps.length : 0

	return (
		<div className="mb-5 rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
				<div>
					<h1 className="text-lg font-semibold text-gray-900">{project?.nazwa || '—'}</h1>
				</div>
				<div className="flex flex-wrap items-center gap-2">
					<Link
						to={`/centrumSzkolen/projekty/edit/${project?._id}`}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100"
					>
						<PencilIcon className="h-4 w-4" />
						<span>{t('projects.list.table.edit')}</span>
					</Link>
				</div>
			</div>

			<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-gray-100 pt-4 text-sm sm:grid-cols-2">
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
						{t('projects.list.table.stepsCount', { defaultValue: 'Etapy' })}
					</dt>
					<dd className="mt-0.5 text-gray-900">{stepsCount}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
						{t('projects.details.fields.created')}
					</dt>
					<dd className="mt-0.5 text-gray-900">{createdDate || '—'}</dd>
				</div>
			</dl>
		</div>
	)
}
